<template>
    <Modal :title="pgettext('label', 'New letter')" @close="close" :closeOnClickOutside="false">
        <Form ref="form"
              @submit="submit"
              class="form form__control hpo-patient-modal-form"
              :validation-schema="schema"
              autocomplete="off"
              :validateOnInput="true">

            <ErrorMessage name="letter" :as="p" class="form__error"/>
            <PrefixKeypad v-model="prefix" class="mt-2 mb-6" />

            <Field type="hidden" name="letter" id="letter" v-model="prefix"/>

            <v-btn :loading="loading" :disabled="loading" :text="pgettext('action', 'Save')" type="submit">
            </v-btn>
        </Form>
    </Modal>
</template>

<script>
import Modal from "@/components/modal/Modal.vue";
import NewFormGroup from "@/components/forms/NewFormGroup"
import * as yup from "yup";
import {useMutation} from "@vue/apollo-composable";
import {handleDjangoForm} from "@/utils/forms";
import {ErrorMessage, Field, Form} from "vee-validate";
import {requiredMessage, stringValidator} from "@/utils/yupValidators";
import {HpoSavePrefixMutation} from "@/graphql/mutations/hpo/patient/savePatient.graphql"
import PrefixKeypad from "@/components/hpo/patientModal/tabs/triage/PrefixKeypad.vue";
import {ref} from "vue";

export default {
    name: 'PrefixModal',
    components: {ErrorMessage, PrefixKeypad, Modal, NewFormGroup, Field, Form},
    emits: ['close'],
    props: {
        hpoId: {
            type: String,
            required: true
        }
    },
    setup() {
        const schema = yup.object({
            letter: stringValidator.length(1, gettext('Please select a letter.')).required(requiredMessage)
        })

        const {mutate, loading} = useMutation(HpoSavePrefixMutation);
        const prefix = ref('');

        return {
            schema,
            mutate,
            loading,
            prefix,
        }
    },
    methods: {
        submit(values) {
            this.mutate({hpoId: this.hpoId, ...values}).then(
                handleDjangoForm(this.$refs.form)
            ).then(result => {
                this.$emit('close')
            }).catch((error) => {
                debugger
            })
        },
        close() {
            this.$emit('close')
        }
    }
}

</script>